import { BfRegionName } from "@/lib/api/models";
import { AuFlag, CaFlag, EuFlag, UsFlag } from "@disasterscience/scaffoldy";
import { Fragment, JSX } from "react";

const FLAG_MAP: Record<BfRegionName, JSX.Element | undefined> = {
    au: <AuFlag />,
    na: (
        <>
            <CaFlag />
            <UsFlag />
        </>
    ),
    usa: <UsFlag />,
    ca: <CaFlag />,
    eu: <EuFlag />,
    sa: undefined,
    af: undefined,
    as: undefined,
    an: undefined,
    global: undefined,
    testy: undefined,
};

export const Flag = (props: { region: BfRegionName | undefined }): JSX.Element => {
    if (!props.region) return <Fragment />;
    const flag = FLAG_MAP[props.region];
    if (!flag) return <Fragment />;
    return <Fragment>{flag}</Fragment>;
};
